// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__oB4pM","footer__title":"Footer_footer__title__C+YTm","footer__author":"Footer_footer__author__HACkB","footer__link":"Footer_footer__link__cRdEf"};